import { Col, Row, Section } from 'components/grid'
import OverlayVideo from 'components/overlay-video'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'
import SectionTitle from 'components/global/SectionTitle'

export default function VideosIntervention({ ...props }) {
	const { language, standard } = useContext(CoreAdoptionContext)

	return (
		<Section margin="mt-8" id={formatSectionId(props)} className="scroll-mt-14">
			<SectionTitle title="Videos" />
			<Row center className="mb-8">
				<Col width="w-2/3">
					<OverlayVideo title="Inspiring a Passion for Reading" />
				</Col>
			</Row>
			<Row center>
				<Col width="w-1/3">
					<OverlayVideo title="ARC Accelerator for Elementary Grades" />
				</Col>
				<Col width="w-1/3">
					<OverlayVideo title="ARC Accelerator for Secondary Grades" />
				</Col>
			</Row>
		</Section>
	)
}
